export const clauseData = {
  title: '服务条款',
  content: ''
}
